import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CtaSectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
  sectionStyle?: 'gradient' | 'light' | 'dark';
}

const CtaSection: React.FC<CtaSectionProps> = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  sectionStyle = 'gradient'
}) => {
  const bgClasses = {
    gradient: 'bg-gradient-to-r from-blue-600 to-indigo-600',
    light: 'bg-gray-50',
    dark: 'bg-gray-900',
  };

  const textClasses = {
    gradient: 'text-white',
    light: 'text-gray-900',
    dark: 'text-white',
  };

  const subtextClasses = {
    gradient: 'text-blue-100',
    light: 'text-gray-600',
    dark: 'text-gray-300',
  };

  const buttonClasses = {
    gradient: 'bg-white text-blue-600 hover:bg-blue-50',
    light: 'bg-blue-600 text-white hover:bg-blue-700',
    dark: 'bg-blue-500 text-white hover:bg-blue-600',
  };

  return (
    <section className={`py-16 md:py-24 ${bgClasses[sectionStyle]}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-2xl md:text-4xl font-bold mb-4 ${textClasses[sectionStyle]}`}>
            {title}
          </h2>
          <p className={`md:text-lg mb-8 ${subtextClasses[sectionStyle]}`}>
            {subtitle}
          </p>
          <Link
            to={buttonLink}
            className={`inline-flex items-center px-8 py-4 rounded-lg font-medium shadow-lg transition duration-300 ${buttonClasses[sectionStyle]}`}
          >
            {buttonText}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;